export default "__VITE_ASSET__ChI2bV0X__"